export enum CashierPreferenceGroups {
  DominantHand = 0,
  ColorBlindness = 1,
  ZoomLevel = 2,
}
